import React from "react";
import { OrderButtonsProps } from "../../OrderButtons/OrderButtons";
import { TableColumns } from "../../../../../requests/table/types";
import { Order } from "../../../../../globalTypes";
import { CheckboxDivTh, FlowioDivTableHead, StyledDivTh } from "./styles";
import { ColumnFormatDict } from "../../../../../requests/templates/types";
import { ColumnLabelOverrides, CustomColumn, CustomColumns } from "../../types";
import Checkbox from "../../../../atoms/inputs/Checkbox";
import useTableHeadColumns from "./useTableHeadColumns";

const TableDataHead = ({
  allowRowSelection,
  columns,
  columnFormatDict,
  order,
  onOrder,
  toggleSelectedStatusForAllRowsOnCurrentPage,
  areAllRowsOnCurrentPageAlreadySelected,
  columnLabelOverrides = {},
  customColumnsToStart,
  customColumnsToEnd,
}: TableDataHeadProps) => {
  const renderCustomCol = (customColumn: CustomColumn) => (
    <StyledDivTh
      key={customColumn.columnName}
      text-align="center"
      className="tableCol stickyCol"
    >
      {customColumn.columnName}
    </StyledDivTh>
  );

  const tableHeadColumns = useTableHeadColumns({
    columns,
    columnFormatDict,
    columnLabelOverrides,
    onOrder,
    order,
  });

  return (
    <FlowioDivTableHead>
      <div className="tableHeaderRow">
        {allowRowSelection && (
          <CheckboxDivTh className="checkboxTh">
            <Checkbox
              checked={areAllRowsOnCurrentPageAlreadySelected}
              onChange={toggleSelectedStatusForAllRowsOnCurrentPage}
            />
          </CheckboxDivTh>
        )}
        {customColumnsToStart?.map(renderCustomCol)}
        {tableHeadColumns}

        {customColumnsToEnd?.map(renderCustomCol)}
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <div className="tableCol stickyCol" />
      </div>
    </FlowioDivTableHead>
  );
};

export type TableDataHeadProps = {
  allowRowSelection: boolean;
  columns: TableColumns;
  columnFormatDict: ColumnFormatDict;
  order: Order;
  toggleSelectedStatusForAllRowsOnCurrentPage: () => void;
  areAllRowsOnCurrentPageAlreadySelected: boolean;
  customColumnsToStart?: CustomColumns;
  customColumnsToEnd?: CustomColumns;
  columnLabelOverrides?: ColumnLabelOverrides;
} & Pick<OrderButtonsProps, "onOrder">;

export default TableDataHead;
